var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStationaryTestsOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "#272D55",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.09961 1V19.2",
    stroke: "#272D55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2998 19.1992H1.0998",
    stroke: "#272D55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.7132C3 14.7132 3.321 11.2842 4.429 11.2842C5.537 11.2842 6.072 16.3552 7.429 14.7132C8.786 13.0712 8.786 6.03424 9.858 4.71324C10.93 3.39224 12.322 12.0342 14.572 12.8562C16.822 13.6782 18.858 7.99925 18.858 7.99925",
    stroke: "#272D55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationaryTestsOperationIcon);
export default __webpack_public_path__ + "static/media/StationaryTestsOperationIcon.501016673883d133eee838cbf246a4fb.svg";
export { ForwardRef as ReactComponent };